<template>
  <div class="container mt-4">
    <h5 class="mb-3">Upload XML Invoice to Peppol</h5>

    <!-- File input -->
    <input
      type="file"
      accept=".xml"
      @change="onFileChange"
      class="form-control mb-3"
    />

    <!-- Submit button -->
    <button
      class="btn btn-primary"
      @click="uploadFile"
      :disabled="!selectedFile"
    >
      Send to Peppol
    </button>

    <!-- Result -->
    <div v-if="response" class="mt-4">
      <h6>Response:</h6>
      <pre>{{ response }}</pre>
    </div>
    <button @click="sendInvoice">SEND A NEW INVOICE</button>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";

export default {
  data() {
    return {
      selectedFile: null,
      response: null,
      access_token: authService.isLoggedIn(), // Load dynamically if needed
    };
  },
  methods: {

     async sendInvoice() {
    try {
      // Prepare your invoice data
      const invoiceData = {
        sender: 'YOUR_VAT_NUMBER',
        recipient: 'RECIPIENT_VAT_NUMBER',
        invoiceNumber: 'INV-001',
        invoiceDate: '2025-10-30',
        totalAmount: 100.00,
        // ...other required fields
      };

      // Send to your backend API (Yii2)
      const response = await axios.post('/mproduct/sendinvoice', invoiceData, {
         headers: {
              Authorization: "Bearer " + this.access_token,
              "Content-Type": "multipart/form-data",
            },
      });

      console.log(response.data);
      alert('Invoice sent successfully!');

    } catch (error) {
      console.error(error);
      alert('Failed to send invoice.');
    }
   
  },

 onFileChange(event) {
      this.selectedFile = event.target.files[0];
    },
    async uploadFile() {
      if (!this.selectedFile) {
        alert("Please select an XML file first!");
        return;
      }

      const formData = new FormData();
      formData.append("file", this.selectedFile);

      try {
        const { data } = await axios.post(
          "/mproduct/sendpeppoltest",
          formData,
          {
            headers: {
              Authorization: "Bearer " + this.access_token,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        this.response = data;
      } catch (error) {
        console.error("Upload failed:", error.response || error);
        alert("Upload failed!");
      }
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 600px;
}
pre {
  background: #f6f8fa;
  padding: 10px;
  border-radius: 6px;
}
</style>
